var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUser = function SvgUser(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M.406 14.215a.633.633 0 1 0 1.266 0A5.65 5.65 0 0 1 4.96 9.07a4.4 4.4 0 0 0 4.818-.005 5.657 5.657 0 0 1 3.282 5.148.633.633 0 1 0 1.265 0 6.91 6.91 0 0 0-2.04-4.92 7 7 0 0 0-1.499-1.128 4.4 4.4 0 0 0 1.007-2.808A4.434 4.434 0 0 0 7.365.929a4.434 4.434 0 0 0-4.429 4.429c0 1.062.377 2.038 1.003 2.802a6.92 6.92 0 0 0-3.533 6.055m6.959-12.02a3.167 3.167 0 0 1 3.163 3.163A3.167 3.167 0 0 1 7.365 8.52a3.167 3.167 0 0 1-3.163-3.163 3.167 3.167 0 0 1 3.163-3.164"
  })));
};
export default SvgUser;